"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRealtimeStocks = exports.GET_REALTIME_STOCKS = void 0;
exports.GET_REALTIME_STOCKS = '/v2/stocks-realtime';
const getRealtimeStocks = (client) => async (sellerId, storableIds) => {
    const res = await client.get(exports.GET_REALTIME_STOCKS + `?sellerId=${sellerId}&storableIds=${storableIds.join(',')}`);
    return res.data;
};
exports.getRealtimeStocks = getRealtimeStocks;
